import axios from "axios";
import SideBar from "./sidebar/ManagerSideBar";
import DashBoardNavbar from "./navbar/DashBoardNavbar";
// export default ProjectDetails;
import * as React from 'react';
import { styled } from '@mui/system';
import TablePagination, {
  tablePaginationClasses as classes,

} from '@mui/base/TablePagination';

import NewUserModal from "../Modals/NewUserModal";
import { useNavigate } from 'react-router';
import AddIcon from "@mui/icons-material/Add";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";


function UserDetails() {
  let navigate = useNavigate();
  const [roles, setroles] = React.useState();
  const [user, setuser] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [currentRole, setCurrentRole] = React.useState("");
  const [modal, setModal] = React.useState(false);
  const [roleID, setRoleID] = React.useState(""); // Initialize roleID state

  const link = ""
  const getData = () => {
    let data = axios.get('/api/users/all', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        setRows(response.data)
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });

  }

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    showSuccessToast(`Rows Per Page changed to ${parseInt(event.target.value, 10)}`)
    setPage(0);
  };
  React.useEffect(() => {
    getData()
    getRoles();

  }, [])
  const blue = {
    200: '#A5D8FF',
    400: '#3399FF',
  };

  const grey = {
    50: '#F3F6F9',
    100: '#E7EBF0',
    200: '#E0E3E7',
    300: '#CDD2D7',
    400: '#B2BAC2',
    500: '#A0AAB4',
    600: '#6F7E8C',
    700: '#3E5060',
    800: '#2D3843',
    900: '#1A2027',
  };

  const Root = styled('div')(
    ({ theme }) => `
    table {
      font-family: IBM Plex Sans, sans-serif;
      font-size: 0.875rem;
      border-collapse: collapse;
      width: 100%;
    }
  
    td,
    th {
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      text-align: left;
      padding: 6px;
    }
  
    th {
      background-color: ${theme.palette.mode === 'dark' ? grey[900] : grey[100]};
    }
    `,
  );

  const CustomTablePagination = styled(TablePagination)(
    ({ theme }) => `
    & .${classes.spacer} {
      display: none;
    }
  
    & .${classes.toolbar}  {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
  
      @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
      }
    }
  
    & .${classes.selectLabel} {
      margin: 0;
    }
  
    & .${classes.select}{
      padding: 2px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      border-radius: 50px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      }
    }
  
    & .${classes.displayedRows} {
      margin: 0;
  
      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
  
    & .${classes.actions} {
      padding: 2px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      border-radius: 50px;
      text-align: center;
    }
  
    & .${classes.actions} > button {
      margin: 0 8px;
      border: transparent;
      border-radius: 2px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      }
    }
    `,
  );

  const getRoles = () => {
    axios.get("/api/roles", {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    }).then((res) => {
      setroles(res.data);
      setRoleID(res.data[0]._id)
    });
  };

  const logOut = () => {
    sessionStorage.clear();
    // navigate('/login')
    navigate("../login", { replace: true });


  }
  const getBackgroundColor = (type) => {
    if (type === 'Viewer') {
      return 'lightblue';
    } else if (type === 'Editor') {
      return 'lightgreen';
    } else if (type === 'Admin') {
      return '#FFC0CB';
    }
  };
  const handleDropdownChange = async (event, row) => {
    const selectedRoleID = event.target.value; // Retrieve selected value
    console.log(selectedRoleID, row._id)
    setRoleID(selectedRoleID); // Update roleID state

    try {
      const response = await axios.post(`/api/users/${row._id}/assign-role`, {
        roleId: selectedRoleID
      }, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
        }
      });
      getData()
      showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
    } catch (error) {
      showErrorToast("Error")
      // Add error handling logic if the POST request fails
    }
  };

  return (
    <body className="g-sidenav-show overflow-hidden bg-gray-200">
      {/* side navbar */}
      <SideBar logOut={logOut} />
      <main className="main-content position-relative h-100 border-radius-lg">
        <DashBoardNavbar user={user} />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-info shadow-info border-radius-lg pt-4 pb-3">
                    <h6 className="text-white text-capitalize ps-3">
                      All Users
                    </h6>
                  </div>
                </div>
                <div className="card-body px-4 pb-2">
                  <div className="table-responsive p-0 d-flex justify-content-center align-items-center">
                    <Root sx={{ width: 1500, maxWidth: '100%' }}>
                      <table aria-label="custom pagination table">
                        <thead>
                          <tr>
                            <th style={{ width: '100px' }}>Sr No.</th>
                            <th>User Name</th>
                            <th className="text-center">Role</th>
                            <th className="text-center">Action</th>

                          </tr>
                        </thead>
                        <tbody>
                          {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                          ).map((row, index) => (
                            <tr key={row._id}>
                              <td>{index + 1}</td>
                              <td style={{ width: 240 }} >{row.username ? row.username : "No user ID rn"}</td>
                              <td style={{ width: 240 }} align="right">
                                <p className=" fw-bold" style={{
                                  backgroundColor: getBackgroundColor(row.role && row.role.role_name),
                                  width: '30%',
                                  padding: '5px',
                                  borderRadius: '10px',
                                  textAlign: 'center',
                                  margin: 'auto'
                                }}
                                >
                                  {row.role ? row.role.role_name : "No Role"}
                                </p>
                              </td>
                              <td className="bg-gray-200 text-center" style={{ width: 240 }} align="right">
                                <select
                                  className="form-select text-center m-auto"
                                  aria-label="Default select example"
                                  style={{ padding: "6px", width: '50%', color: "#495057" }}
                                  onChange={(event) => handleDropdownChange(event, row)}
                                >
                                  {roles?.map((role) => (
                                    <option

                                      value={role._id}
                                      key={role._id}
                                      selected={row.role && role.role_name === row.role.role_name}// Disable the option if the role_name doesn't match
                                    >
                                      {role.role_name}
                                    </option>
                                  ))}
                                </select>
                              </td>

                            </tr>
                          ))}

                          {emptyRows > 0 && (
                            <tr style={{ height: 34 * emptyRows }}>
                              <td colSpan={3} />
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <CustomTablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                              colSpan={3}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              slotProps={{
                                select: {
                                  'aria-label': 'rows per page',
                                },
                                actions: {
                                  showFirstButton: true,
                                  showLastButton: true,
                                },
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </tr>
                        </tfoot>
                      </table>
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div
        style={{
          float: "right",
          marginRight: "20px",
          paddingTop: "15px",
        }}
      >

        <div
          className="fixed-bottom d-flex justify-content-end px-3"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            padding: "10px"
          }}
        >


          <button
            className="btn btn-info"
            onClick={() => setModal(!modal)}
            style={{ float: "left" }}

          >
            <AddIcon /> Add New User
          </button>

          <span
            className="d-sm-inline d-none"
            style={{ marginLeft: "5px" }}
          ></span>
        </div>
      </div>
      <NewUserModal
        getData={getData}
        modal={modal}
        setModal={setModal}
      />
    </body >
  );
}

export default UserDetails;